import ClientPortal from '../../../plugins/axios'

export default {
    signupProvider(signupCredentials) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/signup/provider-signup-validate`, signupCredentials)
    },
    async getCsrfToken() {
    // console.log("getcsrf default store api signupapi")
        const csrf = await ClientPortal.get(`${process.env.VUE_APP_API}/signup/getCsrfToken`)
        // console.log('csrf log in getCsrfToken: ', csrf);
        return csrf
    },
    validationOneTwo(signupCredentials) {
    // console.log("val12 signupcred store api signupapi")
        return ClientPortal.post( `${process.env.VUE_APP_API}/signup/validationOneTwo`, signupCredentials)    
    },
    validationThree(signupCredentials) {
    // console.log("val3 signupcred store api signupapi")
        return ClientPortal.post( `${process.env.VUE_APP_API}/signup/validationThree`, signupCredentials)
    },
    validationFour(userCredentials) {
    // console.log("val4 user cred store api signupapi")
        return ClientPortal.post( `${process.env.VUE_APP_API}/signup/validationFour`, userCredentials
            // console.log("GOODS val4 user cred store api signupapi", process.env.VUE_APP_API)
        )
    },
  
    resendMail(userCredentials) {
    // console.log("resndmail store api signupapi")
        return ClientPortal.post( `${process.env.VUE_APP_API}/signup/resendMail`, userCredentials)
    }
}
